import { render, staticRenderFns } from "./ImageInfo.vue?vue&type=template&id=282020bc&scoped=true&"
import script from "./ImageInfo.vue?vue&type=script&lang=tsx&"
export * from "./ImageInfo.vue?vue&type=script&lang=tsx&"
import style0 from "./ImageInfo.vue?vue&type=style&index=0&id=282020bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282020bc",
  null
  
)

export default component.exports